import { withChartLayout } from 'components/common';
import GeneralOrders from 'components/features/chart/order-entry/general-orders/GeneralOrders';

const GeneralOrdersPage = withChartLayout('General Orders')(GeneralOrders);
export default GeneralOrdersPage;
